// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__29-N0","ranges":"BmiRanges_ranges__1HerB"};